import { getCurrentProfileSelect } from '@gymaholic/packages'
import Button from 'components/Button'
import { GymaholicLogoLink } from 'components/Icon/icons/gymaholic'
import { MenuIcon } from 'components/Icon/icons/menu'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { navItems } from 'pages/Creators/Header/navItems.js'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import Link from 'components/Link'
import getLocationRouterSelect from 'modules/router/selectors/get-location'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

export default function CreatorHeader () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const dispatch = useDispatch()
  const intl = useIntl()
  const currentProfile = useSelector(getCurrentProfileSelect)
  const location = useSelector(getLocationRouterSelect)

  const handleClickMobileHeader = () => {
    dispatch(openModalAction(MODAL_ID.MOBILE_HEADER))
  }

  const isRouteActive = (path) => {
    return location.pathname === path
  }

  const getPath = (value) => {
    if (value === ROUTE_PATH.CREATOR_LOGIN && currentProfile) {
      return ROUTE_PATH.ACCOUNT
    } else {
      return value
    }
  }

  return (
    <View
      row
      h={isSmallScreen ? '70px' : '110px'}
      ac
      style={{ justifyContent: 'space-between' }}
      px={isSmallScreen ? '20px' : 0}

    >
      <GymaholicLogoLink />
      {!isSmallScreen
        ? (
          <View
            row
            style={{ gap: '23px' }}
          >
            {navItems.map((navItem, index) => (
              <Link
                key={index}
                to={getPath(navItem.path)}
                style={{ padding: '10px' }}
              >
                <Text
                  c='#151D21'
                  fw={isRouteActive(navItem.path) ? '890' : '590'}
                  fs='13px'
                  style={{
                    textTransform: 'uppercase'
                  }}
                >
                  {formatMessageIntlUtil(intl, navItem.name)}
                </Text>
              </Link>
            ))}
          </View>
          )
        : (
          <Button
            onClick={handleClickMobileHeader}
            style={{
              width: 'unset',
              height: 'unset',
              maxWidth: 'unset'
            }}
          >
            <MenuIcon style={{
              width: '22px',
              height: '22px'
            }}
            />
          </Button>
          )}
    </View>
  )
}
